import React, { useEffect, useState } from "react";
import * as Icons from "heroicons-react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import powered from "../../../../logo-dark.svg";
import { signInUser } from "../../../Utility/Auth";

import {
  salesAmountRecived,
  saleCash,
  saleCardName,
  saleCardAmount,
  saleMfsName,
  saleMfsAmount,
  salePointAmount,
  saleDiscount,
  selcetBiller,
  selectWarehouse,
  setDue,
} from "../../../../features/posSlice";
import { useDispatch, useSelector } from "react-redux";

const PosFinalizes = React.forwardRef(
  ({
    // customer,
    handlePrintBill,
    billPrintButton,
    // returnCal,
    usePointChecked,
    usePointCheckbox,
    discountChecked,
    // setDiscountChecked,
    discountCheckbox,
    useDueCheckbox,
    useDueChecked,
    isBill,
    settings,
  }) => {
    const dispatch = useDispatch();
    const saleCal = useSelector((state) => state.posReducer);
    const user = signInUser();

    const activeMfs = settings?.paymentMethods?.filter(m => m.type === "mfs" && m.status !== false) || [];
    const activeCards = settings?.paymentMethods?.filter(m => m.type === "card" && m.status !== false) || [];

    const mfsOptions = activeMfs.length > 0 ? activeMfs : [
      { order: "bKash", name: "Bkash" },
      { order: "Nagad", name: "Nagad" },
      { order: "Upay", name: "Upay" },
      { order: "Rocket", name: "Rocket" }
    ];

    const cardOptions = activeCards.length > 0 ? activeCards : [
      { order: "visa", name: "VISA" },
      { order: "DBBL", name: "DBBL" },
      { order: "MTB", name: "MTB" },
      { order: "CITY", name: "CITY" },
      { order: "AMEX", name: "AMEX" },
      { order: "EBL", name: "EBL" },
      { order: "BRAC", name: "BRAC" },
      { order: "masterCard", name: "Master Card" }
    ];

    useEffect(() => {
      if (mfsOptions.length > 0) {
        const selectedMfs = saleCal?.paidAmount?.mfs?.name;
        const exists = mfsOptions.some(opt => opt.order === selectedMfs);
        if (!exists) {
          dispatch(saleMfsName(mfsOptions[0].order));
        }
      }
    }, [settings, dispatch, saleCal?.paidAmount?.mfs?.name, mfsOptions]);

    useEffect(() => {
      if (cardOptions.length > 0) {
        const selectedCard = saleCal?.paidAmount?.card?.name;
        const exists = cardOptions.some(opt => opt.order === selectedCard);
        if (!exists) {
          dispatch(saleCardName(cardOptions[0].order));
        }
      }
    }, [settings, dispatch, saleCal?.paidAmount?.card?.name, cardOptions]);



    return (
      <div className="container-fluid z-3">
        <div className="card sticky-md-top">
          <div className="card-body mb-2">
            <div className="row">
              <div className="col-8">
                <h5 className="card-title">Finalize Sale</h5>
              </div>
              <div className="col-4">
                <div className="d-flex justify-content-end">
                  <Form.Group controlId="formBasicCheckbox">
                    <Form.Check
                      type="checkbox"
                      label="Due Bill"
                      onChange={() => dispatch(setDue(!saleCal.due))}
                      checked={saleCal.due}
                      disabled={
                        saleCal.customerId === "62e301c1ee6c8940f6ac1515"
                      }
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
            <hr />
            <form id="finalizeForm" onSubmit={handlePrintBill}>
              <p className="card-text">
                <b>Total Item: </b>{" "}
                <span className="float-end"> {saleCal?.totalItem}</span>
              </p>
              {saleCal.returnCal?.totalItem > 0 && (
                <p className="card-text">
                  <b>Return Item: </b>{" "}
                  <span className="float-end">
                    {" "}
                    {parseFloat(saleCal.returnCal.totalItem)}
                  </span>
                </p>
              )}

              <p className="card-text">
                <b>Total: </b>
                <span className="float-end">
                  {" "}
                  {parseFloat(saleCal?.total).toFixed(2)}
                  BDT
                </span>
              </p>
              {saleCal.returnCal?.total > 0 && (
                <p className="card-text">
                  <b>Return Total: </b>
                  <span className="float-end">
                    {" "}
                    {parseFloat(saleCal.returnCal.grossTotal).toFixed(2)}BDT
                  </span>
                </p>
              )}
              {/* <p className="card-text">
            <b>Discount Amount: </b>{" "}
            <span className="float-end"> {sales.discount} BDT</span>
          </p> */}
              <p className="card-text">
                <b>Discount: </b>{" "}
                <span className="float-end">
                  {" "}
                  {parseFloat(saleCal?.discount)?.toFixed(2)}
                  BDT
                </span>
              </p>
              {saleCal?.vatAmount > 0 && (
                <p className="card-text">
                  <b>VAT: </b>
                  <span className="float-end">
                    {" "}
                    {parseFloat(saleCal?.vatAmount).toFixed(2)}
                    BDT
                  </span>
                </p>
              )}
              <p className="card-text">
                <b>Gross Total: </b>
                <span className="float-end">
                  {parseFloat(saleCal?.grossTotal)?.toFixed(2)}
                  BDT
                </span>
              </p>
              <p className="card-text">
                <b>Gross Total(Round): </b>
                <span className="float-end">
                  {parseFloat(saleCal?.grossTotalRound)?.toFixed(2)}
                  BDT
                </span>
              </p>
              <p className="card-text align-middle">
                <div className="row">
                  <div className="col-md-6">
                    <b>Cash Received: </b>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="number"
                      onChange={(e) =>
                        dispatch(
                          saleCash(e.target.value > 0 ? e.target.value : 0)
                        )
                      }
                      id="cashAmount"
                      defaultValue={0}
                      min={0}
                      value={saleCal?.paidAmount?.cash}
                      className="form-control float-end col-7"
                    />
                  </div>
                </div>
              </p>
              <p className="card-text align-middle">
                <div className="row">
                  <div className="col-md-3">
                    <b>Card: </b>
                  </div>
                  <div className="col-md-5 ">
                    <Form.Select
                      name="cardType"
                      onChange={(e) => dispatch(saleCardName(e.target.value))}
                      id="cardType"
                      aria-label="Default select example"
                      value={saleCal?.paidAmount?.card?.name || ""}
                    >
                      {cardOptions.map((opt) => (
                        <option key={opt.order} value={opt.order}>
                          {opt.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="col-md-4 mt-2 mt-md-0">
                    <input
                      disabled={saleCal.due}
                      type="number"
                      defaultValue={0}
                      onChange={(e) =>
                        dispatch(
                          saleCardAmount(
                            parseInt(e.target.value > 0 ? e.target.value : 0)
                          )
                        )
                      }
                      min={0}
                      value={saleCal?.paidAmount?.card?.amount}
                      name="cardAmount"
                      id="cardAmount"
                      className="form-control float-end col-12"
                    />
                  </div>
                </div>
              </p>
              <p className="card-text align-middle">
                <div className="row">
                  <div className="col-md-3">
                    <b>MFS: </b>
                  </div>
                  <div className="col-md-5">
                    <Form.Select
                      name="mfsName"
                      onChange={(e) => dispatch(saleMfsName(e.target.value))}
                      id="mfsName"
                      aria-label="Default select example"
                      value={saleCal?.paidAmount?.mfs?.name || ""}
                    >
                      {mfsOptions.map((opt) => (
                        <option key={opt.order} value={opt.order}>
                          {opt.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="col-md-4 mt-2 mt-md-0">
                    <input
                      type="number"
                      id="mfsAmount"
                      defaultValue={0}
                      disabled={saleCal.due}
                      onChange={(e) =>
                        dispatch(
                          saleMfsAmount(e.target.value > 0 ? e.target.value : 0)
                        )
                      }
                      value={saleCal?.paidAmount?.mfs?.amount}
                      name="mfsAmount"
                      className="form-control float-end col-12"
                    />
                  </div>
                </div>
              </p>
              {saleCal?.point?.old >= 100 && (
                <p className="card-text align-middle">
                  <div className="row">
                    <div className="col-md-4">
                      <b>
                        <Form.Group
                          className="mb-3"
                          controlId="formBasicCheckbox"
                        >
                          <Form.Check
                            disabled={saleCal.due}
                            type="checkbox"
                            label="Use Point: "
                            onChange={usePointCheckbox}
                            checked={usePointChecked}
                          />
                        </Form.Group>
                        {/* Use Point:  */}
                      </b>
                    </div>
                    <div className="col-md-4">{saleCal?.point?.old}</div>
                    <div className="col-md-4">
                      <input
                        disabled={usePointChecked === false && "disabled"}
                        type="number"
                        onChange={(e) =>
                          e.target.value <= saleCal?.point?.old &&
                          dispatch(
                            salePointAmount(
                              e.target.value > 0 ? e.target.value : 0
                            )
                          )
                        }
                        id="pointAmount"
                        defaultValue={0}
                        min={0}
                        max={saleCal?.point?.old}
                        value={saleCal.paidAmount?.point}
                        className="form-control float-end col-7"
                      />
                    </div>
                  </div>
                </p>
              )}
              <p className="card-text align-middle">
                <div className="row">
                  <div className="col-md-6">
                    <b>
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicCheckbox"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Discount: "
                          onChange={discountCheckbox}
                          checked={discountChecked}
                        />
                      </Form.Group>
                    </b>
                  </div>
                  <div className="col-md-6 d-flex gap-2 justify-content-center  align-items-center">
                    {saleCal?.group !== null && "10% "}
                    <input
                      disabled={discountChecked === false && "disabled"}
                      type="number"
                      onChange={(e) =>
                        dispatch(
                          saleDiscount(
                            parseInt(e.target.value > 0 ? e.target.value : 0)
                          )
                        )
                      }
                      id="discount"
                      defaultValue={0}
                      min={0}
                      value={Math.round(saleCal.discount) || "0"}
                      className="form-control float-end"
                    />
                  </div>
                </div>
              </p>
              {/* {console.log(saleCal.point)} */}
              <p className="card-text">
                <b>Change Amount: </b>{" "}
                <span className="float-end">
                  {saleCal?.changeAmount?.toFixed(2)}
                  BDT
                </span>
              </p>
              {saleCal?.promo_discount > 0 && (
                <p className="card-text">
                  <b>Promo Discount: </b>{" "}
                  <span className="float-end">
                    {saleCal?.promo_discount?.toFixed(2)}
                    BDT
                  </span>
                </p>
              )}

              {/* {customer !== "62e301c1ee6c8940f6ac1515" && ( */}
              <p className="card-text">
                <span className="float-start">
                  <b>Old Point: </b>
                  {saleCal?.point?.old}
                </span>
                <span className="float-end">
                  <b>New Point: </b>
                  {saleCal?.point?.new}
                </span>
              </p>
              {/* )} */}

              <br />
              <hr />
              <p className="text-center m-0">
                <button
                  ref={billPrintButton}
                  className="btn btn-dark btn-block "
                  id="billPrintButton"
                  type="submit"
                  disabled={isBill}
                >
                  <Icons.PrinterOutline className="me-2" size={18} /> Print Bill
                </button>
              </p>
            </form>
          </div>
          <div className="card-footer">
            <div className="text-center">
              <span
                className="text-sm"
                style={{ fontSize: "12px", color: "#6c757d" }}
              >
                Powered by:
              </span>
              <Link to="https://techsoulbd.com/">
                <img src={powered} height="25" alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default PosFinalizes;
